var map = {
	"./Comdirect_icon.png": "db6f",
	"./ING_icon.png": "b835",
	"./OnVista_icon.png": "6461",
	"./Webseite_Mockup_sigmafolio.png": "2351",
	"./flatex_icon.png": "b88a",
	"./portfolio_snapshot2.png": "99db",
	"./return_vs_risk.png": "591a",
	"./sample-diversification2.png": "50bb",
	"./sample-performance.png": "62ac",
	"./sample-recommendations2.png": "de18",
	"./tick_large_cross.png": "69b8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9142";